






















































import {Component, Vue} from 'vue-property-decorator';
import signalDiagramModule from '@/store/modules/signalDiagramModule';
import spectrumDiagramModule from '@/store/modules/spectrumDiagramModule';
import Card from '@c/Card.vue';
import {uuidv4} from '@/utils/uuidUtils';
import {PModuleWithMeasurements, PModuleEvent} from '@/views/system/modules/interfaces';
import {PMEventType} from '@/views/system/modules/enums';
import measurementsModule from '@/store/modules/entities/measurementsModule';
import SignalDiagramBox from '@c/diagrams/SignalDiagramBox.vue';
import SpectrumDiagramBox from '@c/diagrams/SpectrumDiagramBox.vue';
import {getSignalDiagramTitle, getSpectrumDiagramTitle} from '@c/diagrams/utils';
import {SignalDiagramData, SpectrumDiagramData} from '@c/diagrams/interfaces';
import {MeasurementType} from '@/views/system/measurements/enums';
import {
  pmoduleStoresByTypeMap,
  pmoduleEventBoundaryPassedDataRoutesByTypeMap,
} from '@/views/system/modules/configurate';
import {PModuleType} from '@/enums/configs';
import {PModuleStoreModule} from '@/store/modules/entities/pmodules/interfaces';
import Loading from '@c/controls/Loading.vue';
import PModuleButtons from './PModuleButtons.vue';
import PingerModuleIpCard from './PingerModuleIpCard.vue';
import HeaterMonitorModuleWorkloadCard from './HeaterMonitorModuleWorkloadCard.vue';
import dtcpTahoModule from '@/store/modules/entities/pmodules/dtcp/dtcpTahoStoreModule';

@Component({
  components: {
    SignalDiagramBox,
    SpectrumDiagramBox,
    Card,
    Loading,
    PModuleButtons,
    PingerModuleIpCard,
    HeaterMonitorModuleWorkloadCard,
  },
})
export default class PModuleCard extends Vue {
  // Программный модуль
  pmodule: PModuleWithMeasurements | null = null;

  // Показатели загрузки данных и ошибки
  loading = true;
  error = false;

  // Диаграммы сигналов
  signalDiagrams: SignalDiagramData[] = [];

  // Диаграммы спектров
  spectrumDiagrams: SpectrumDiagramData[] = [];

  // События ПМ
  events: PModuleEvent[] = [];

  get isPingerModule() {
    return this.pmodule?.type == PModuleType.PingerModule;
  }

  get isHeaterMonitorModule() {
    return this.pmodule?.type == PModuleType.HeaterMonitorModule;
  }

  // Получить хранилище
  get apiStore(): PModuleStoreModule {
    return (pmoduleStoresByTypeMap.get(
      (this.$attrs.type as any) as PModuleType,
    ) as any) as PModuleStoreModule;
  }

  // Получить измерение по id
  getMeasurementById(id: number) {
    const data = measurementsModule.all.filter(x => x.id === id);
    if (data.length) return data[0];
    return null;
  }

  get span_nodes() {
    return this.pmodule?.span_nodes?.filter((n: any) => !n.is_deleted);
  }

  // TODO: Вынести этот код в mixin
  async created() {
    try {
      await measurementsModule.fetchAll();
      const {data} = await this.apiStore.getById(this.$attrs.id);
      this.pmodule = data as PModuleWithMeasurements;

      if (!this.pmodule || !this.pmodule.measurements) return;

      if (this.pmodule.span_nodes) {
        if (!dtcpTahoModule.all.length) {
          await dtcpTahoModule.fetchAll();
        }
        this.pmodule.span_nodes = this.pmodule.span_nodes.map((n: any) => {
          if (n.is_deleted) return n;
          if (!n.taho_module_uuid) return n;
          const taho = dtcpTahoModule.all.find(m => m.guid == n.taho_module_uuid);
          const newval = {
            ...n,
            taho_module: taho,
          };
          return newval;
        });
      }

      this.pmodule.measurements.forEach(x => {
        if (!x.measurementId) return;
        const measurement = this.getMeasurementById(x.measurementId);
        if (!measurement) return;

        if (measurement.type === MeasurementType.Signal) {
          const moduleId = this.pmodule?.id as number;
          const moduleGUID = this.pmodule?.guid as string;
          const moduleType = this.pmodule?.type as PModuleType;
          this.signalDiagrams.push({
            id: uuidv4(),
            moduleId: moduleId,
            moduleGUID: moduleGUID,
            moduleType: moduleType,
            name: getSignalDiagramTitle(measurement),
            measurement: measurement,
            topBoundary: x.topWarningBoundary,
            bottomBoundary: x.bottomWarningBoundary,
            visible: true,
          });
        }
        if (measurement.type === MeasurementType.Spectrum) {
          const moduleId = this.pmodule?.id as number;
          const moduleGUID = this.pmodule?.guid as string;
          const moduleType = this.pmodule?.type as PModuleType;
          this.spectrumDiagrams.push({
            id: uuidv4(),
            moduleId: moduleId,
            moduleGUID: moduleGUID,
            moduleType: moduleType,
            name: getSpectrumDiagramTitle(measurement),
            measurement: measurement,
          });
        }
      });

      if (this.signalDiagrams) signalDiagramModule.setCanSync({diagrams: [...this.signalDiagrams]});

      if (this.spectrumDiagrams)
        spectrumDiagramModule.setCanSync({diagrams: [...this.spectrumDiagrams]});

      this.events = await this.apiStore.getEventTypes();
    } catch (errorData) {
      if (Vue.config.devtools) {
        // печатаем ошибку в режиме разработки
        console.error(errorData);
      }
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  // Проверяем есть ли у модуля событие "Выход за границу"
  get isLink() {
    return (
      this.pmodule &&
      this.events.filter((e: PModuleEvent) => e.type === PMEventType.BoundaryPassed)[0]
    );
  }

  /*
    Переход на страницу показа события "Выход за границу"
  */
  async link() {
    if (!this.pmodule) return;
    const {href} = this.$router.resolve({
      name: pmoduleEventBoundaryPassedDataRoutesByTypeMap.get(this.pmodule?.type),
      params: {id: `${this.pmodule?.id}`},
    });
    window.open(href, '_blank');
  }

  beforeDestroy() {
    signalDiagramModule.clear();
    spectrumDiagramModule.clear();
  }
}
